// extracted by mini-css-extract-plugin
export default {"servicesBg":"Services_servicesBg__n0vkp","servicesContainer":"Services_servicesContainer__5X9Ax","services":"Services_services__YZhTH"};